import { MODULE_NAMESPACE as BAG_MODULE_NAMESPACE } from '@common-vue/my-bag-consumable';
import {
  MODULE_NAMESPACE as CHECKOUT_MODULE_NAMESPACE,
  STS_MODULE_NAMESPACE,
  handleResponseSessionHeaders, OOPSTRACKER_ID as oopsTrackerId,
} from '@common-vue/my-checkout-consumable';

const CXUI_PICKUP = '/cxui/pickup';
/**
 * Important: do NOT change webpackChunkName for the views. These names are used for preloading.
 */
export default () => [
  {
    name: 'my-bag',
    paths: ['/my/bag', '/my/bag/'],
    component: () => import(/* webpackChunkName: "BagView" */'@views/Bag'),
    store: async () => {
      // Having same bundle name here is to bundle both to same file
      const [{ default: store }, { default: bagUpdatePlugin }] = await Promise.all([
        import(/* webpackChunkName: "BagViewStore" */'@common-vue/my-bag-consumable/store'),
        import(/* webpackChunkName: "BagViewStore" */'@common-vue/my-bag-consumable/store/plugins/bagUpdatePlugin'),
      ]);
      return {
        store,
        namespace: BAG_MODULE_NAMESPACE,
        plugins: [bagUpdatePlugin],
      };
    },
  },
  {
    name: 'my-checkout',
    paths: ['/my/checkout'],
    component: () => import(/* webpackChunkName: "CheckoutView" */ '@views/Checkout'),
    handleResponseSessionHeaders,
    oopsTrackerId,
    store: async () => {
      const [{ default: store }] = await Promise.all([
        import(/* webpackChunkName: "CheckoutViewStore" */'@common-vue/my-checkout-consumable/store'),
      ]);
      return {
        store,
        namespace: CHECKOUT_MODULE_NAMESPACE,
      };
    },
  },
  {
    name: 'cxui-pickup',
    paths: [CXUI_PICKUP],
    component: () => import(/* webpackChunkName: "SaveTheSale" */ '@views/SaveTheSale'),
    store: async () => {
      const [{ default: store }] = await Promise.all([
        import(/* webpackChunkName: "SaveTheSaleViewStore" */'@common-vue/my-checkout-consumable/saveTheSaleStore'),
      ]);
      return {
        store,
        namespace: STS_MODULE_NAMESPACE,
      };
    },
  },
];

export function getInternalRoutePath() {
  const locationPathName = window.location.pathname;
  // For CXUI, locationPathName can be '/cxui/pickup' or '/cxui/pickup/sometoken
  // Both needs to be handled in app.vue to get the right route using route getRoutes()
  // routeDetails.paths.includes(routePath)
  if (locationPathName.indexOf(CXUI_PICKUP) === 0) {
    return CXUI_PICKUP;
  }
  return locationPathName;
}
